import { render, staticRenderFns } from "./UserWidthdraw.vue?vue&type=template&id=030bccef&scoped=true&"
import script from "./UserWidthdraw.vue?vue&type=script&lang=js&"
export * from "./UserWidthdraw.vue?vue&type=script&lang=js&"
import style0 from "./UserWidthdraw.vue?vue&type=style&index=0&id=030bccef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030bccef",
  null
  
)

export default component.exports